import { useState, useEffect } from "react"
import { Box, Grid, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import TablaTicketService from "../../services/tablaTicket.service";
import FechaFunction from "../../function/FechaFunction";
import { useNavigate } from "react-router-dom";

const HomeAsesorScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [tickets, setTickets] = useState();
    const navigate = useNavigate();

    const actualizar = (data) => {
        TablaTicketService.countTicketTic(data).then((c)=>{
            setTickets(c)
        })
    }
    useEffect(() => {
        document.title = `Zeta-CRM`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', bgcolor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} mb={20}>
                <Grid item xs={12} md={4} lg={4}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h1">Dashboard Asesor</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default HomeAsesorScreen;